/** Browser-safe upload policy. Detection and decoder validation remain server-side. */
export const IMAGE_UPLOAD_ACCEPT = 'image/*,.heic,.heif,.hif,.avif,.webp,.jfif,.tif,.tiff,.bmp,.gif,.apng,.ico,.psd,.tga,.jxl,video/mp4,video/quicktime,video/webm,video/x-msvideo,video/x-matroska,video/3gpp,.mp4,.mov,.m4v,.webm,.avi,.mkv,.3gp,.3g2';
export const ARTWORK_UPLOAD_ACCEPT = `${IMAGE_UPLOAD_ACCEPT},.svg,.pdf,.ai,.eps,application/pdf,application/postscript,application/illustrator`;
export const MAX_IMAGE_UPLOAD_BYTES = 40 * 1024 * 1024;
export const MAX_IMAGE_PIXELS = 100_000_000;
export type ImageUploadNotice = 'converted' | 'first_image' | 'video_frame' | 'hdr_tonemapped' | 'flattened';
export interface ImageUploadInfo {
  mime: 'image/png' | 'image/jpeg';
  filename: string;
  width: number;
  height: number;
  notices: ImageUploadNotice[];
}
export const IMAGE_UPLOAD_MESSAGES: Record<ImageUploadNotice, string> = {
  converted: 'Slika je pripremljena bez smanjivanja rezolucije.',
  first_image: 'Fajl sadrži više slika ili animaciju. Koristi se prva slika — proveri pregled.',
  video_frame: 'Iz videa je izdvojena jedna slika. Proveri kadar u pregledu; pošalji drugu sliku ako ti ne odgovara.',
  flattened: 'Koristi se spojena slika iz PSD fajla. Slojevi se ne uvoze — proveri pregled.',
  hdr_tonemapped: 'HDR boje su prilagođene standardnom prikazu i štampi — proveri pregled.',
};

export const IMAGE_UPLOAD_MESSAGES_EN: Record<ImageUploadNotice, string> = {
  converted: 'Prepared as PNG at the original resolution.',
  first_image: 'Only the first image or animation frame is used. Check the preview.',
  video_frame: 'One image was extracted from the video. Check the chosen frame in the preview.',
  flattened: 'The flattened PSD composite is used. Layers are not imported; check the preview.',
  hdr_tonemapped: 'HDR colors were adapted for standard display and print. Check the preview.',
};
